window.InifECApp.directive('editUserremark', ['$rootScope', '$ngModal', 'ShoppingCartService', function ($rootScope, $ngModal, ShoppingCartService) {

    var _dir = {};

    var controller = ['$scope', function($scope) {

        var submit = function() {

            if($scope.isLoading) {
                return;
            }

            var orderitemid = $scope.orderitem.orderitemid,
                userRemark = $scope.form.userRemark,
                cartType = $scope.cartType;

            $scope.isLoading = true;

            ShoppingCartService.updateUserRemark(orderitemid, userRemark, cartType).then(function() {
                $scope.isLoading = false;
                ($scope.callback) && $scope.callback(userRemark);
                closeModal();
            }, function(error) {
                $scope.isLoading = false;
                $scope.isError = true;
            });
        }

        var cancel = function() {

            if($scope.isLoading) {
                return;
            }

            closeModal();
        }

        // ===============================
        //  開啟 modal
        // ===============================
        var openModal = function() {
            $ngModal.openModal('edit-userremark-modal');
        }

        // ===============================
        //  關閉 modal
        // ===============================
        var closeModal = function() {
            $ngModal.closeModal('edit-userremark-modal');
        }

        var init = function() {
            $scope.isLoading = false;

            if($scope.orderitem.name) {
                $scope.title = $scope.orderitem.name + "的備註說明";
            } else {
                $scope.title = "編輯備註說明";
            }

            $scope.form.userRemark = $scope.orderitem.userRemark;

            openModal();
        }

        /*==========================
            Events
        ==========================*/            
        $scope.$on('SHOW_EDIT_USER_REMARK_MODAL', function(event, data) {

            if(data) {
                $scope.orderitem = data.orderitem;
                $scope.callback = data.callback;
                $scope.cartType = data.cartType;

                init();
            }
        });

        /*==========================
            Members
        ==========================*/
        $scope.title = undefined;
        $scope.form = {
            userRemark: '',
        };
        $scope.cartType;

        $scope.isLoading = false;
        $scope.isError = false;

        /*==========================
            Methods
        ==========================*/
        $scope.openModal = openModal;
        $scope.closeModal = closeModal;
        $scope.submit = submit;
        $scope.cancel = cancel;
        $scope.callback;

        
        /*==========================
            init
        ==========================*/

    }]

    _dir.restrict = "E";
    _dir.scope = true;
    _dir.templateUrl = "partials/modal/edit_userremark.html";
    _dir.controller = controller;

    return _dir;
}]);